/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Seo_Description1Inputs */

const vi_cmspost_seo_description1 = /** @type {(inputs: Cmspost_Seo_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả SEO (để trống = mô tả ngắn)`)
};

/**

* @param {Cmspost_Seo_Description1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_seo_description1 = /** @type {((inputs?: Cmspost_Seo_Description1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Seo_Description1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_seo_description1(inputs)
});
export { cmspost_seo_description1 as "cmsPost_seo_description" }